import {HTTP} from '@/CallAPI'
export default {
  getListTag (page = 1, per_page = '') {
    return HTTP.get('tags', {params: {
      page,
      per_page
    }})
  },
  createTag (tag) {
    return HTTP.post('tags', tag)
  },
  updateTag (tag) {
    return HTTP.put('tags/' + tag.id, tag)
  },
  showTag (tag) {
    return HTTP.get('tags/' + tag.id)
  },
  destroyTag (tag) {
    return HTTP.delete('tags/' + tag.id)
  },
  syncChkitems (payload) {
    return HTTP.post('tags/checklist-items', {params: {'tag': payload.tag, 'checklist_items': payload.chk_items}})
  }
}



// WEBPACK FOOTER //
// ./src/service/tag.js